exports.LANGUAGE_DE = 'de';
exports.LANGUAGE_FR = 'fr';
exports.LANGUAGES = [exports.LANGUAGE_DE, exports.LANGUAGE_FR];
